<template>
  <div class="app-container">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <van-cell-group title="在线缴费-在线缴税">
        <van-cell
          title="在线缴费"
          label="用于实现在线缴费"
          size="large"
          to="/online/zxzf"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="在线缴税"
          label="用于实现在线缴税"
          size="large"
          to="/online/zxjs"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
      </van-cell-group>
    </template>
  </div>
</template>

<script>
import { getApplicationShortcutList } from '@/api/application'

export default {
  filters: {
    iconName(name) {
      return name || 'all'
    },
    iconColor(color) {
      return color || '#666'
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      shortcuts: []
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      getApplicationShortcutList({
        isEnabled: true
      }).then(({ data }) => {
        this.shortcuts = data
        this.isLoaded = true
      }).catch(error => {
        this.errorMessage = error.message
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
  .loading{
    padding-top: 15px;
    text-align: center;
  }
  .error-message{
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .van-cell:not(:last-child)::after {
    left: 54px;
    border-bottom: 1px solid #d9d9d9;
  }
}
</style>
